export default __webpack_public_path__ + "static/media/keys_to_my_wishes.b615d491.png";